import React, { useCallback } from "react";
import styled from "styled-components";
import { injectIntl } from "react-intl";

const PaginationIcon = styled.div`
  font-size: ${(props) => (props.fontSize ? props.fontSize : "20")}px;
  position: relative;
  top: 1px;
`;

const PaginationStepBtn = styled.button`
  width: 40px;
  text-align: center;
  font-size: 20px;
  display: inline-block;
  border-radius: 0px;
  border: none;
  background: none;

  outline: 0 !important;
  cursor: pointer;

  transition: all 0.3s ease;
  color: ${(p) => p.theme.colors.on.surface} !important;

  &:disabled {
    // color: rgb(216, 216, 216) !important;
    cursor: default;
    opacity: 0.3;
  }

  &:hover:not(:disabled) {
    //background-color: rgb(216, 216, 216, 0) !important;
    // color: #1890ff !important;
    opacity: 0.7;
  }
`;

const PaginationBtn = styled.div`
  width: 200px;
  text-align: center;
  font-size: 20px;
  display: inline-block;
  border-radius: 60px;

  font-weight: 300;
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1em 3em;
`;

const PaginationLeft = styled.div`
  display: flex;
  min-width: 90px;
  justify-content: space-between;
`;

const PaginationCenter = styled.div``;

const PaginationText = styled.div`
  font-size: 14px;
  padding: 8px 0px;
  border: none;
  //color: rgba(0, 0, 0, 0.8);
  font-weight: 400;
`;

const PaginationRight = styled.div`
  display: flex;
  min-width: 90px;
  justify-content: space-between;
`;

const PaginationBar = (props) => {
  const {
    totalCount = 100,
    pageSize = 10,
    page = 1,
    loading = false,
    setPage = () => {},
    intl,
  } = props;

  // calculate pagination
  var numPaginationButtons = Math.ceil(totalCount / pageSize);

  // const [ page,setDebouncedPage ] = useState(page)

  const _setPage = useCallback((e) => {
    const toPage = e.currentTarget.dataset.page;

    setPage(toPage);
    // setDebouncedPage(toPage)
  });

  /* const debouncedValue = useDebounce(page, 250); */

  /* useEffect(() => {
        setPage(debouncedValue)
    }, [debouncedValue]) */

  const fromPages = (page - 1) * pageSize + 1;
  let toPages = (page - 1) * pageSize + pageSize;

  if (totalCount && +toPages > +totalCount) {
    toPages = totalCount;
  }

  // we only set totalCount if we have a totalCount value, else we set empty string
  const postLabel = totalCount
    ? ` ${intl.formatMessage({ id: "of" })} ${totalCount}`
    : ``;

  return (
    <PaginationWrapper>
      <PaginationLeft>
        <PaginationStepBtn
          disabled={+page === 1 ? true : false || loading}
          data-page={1}
          onClick={+page === 0 ? () => {} : _setPage}
          aria-label="First page"
        >
          <PaginationIcon fontSize={20} className="far fa-arrow-to-left" />
        </PaginationStepBtn>
        <PaginationStepBtn
          disabled={+page === 1 ? true : false || loading}
          data-page={+page - 1}
          onClick={+page === 0 ? () => {} : _setPage}
          aria-label="Previous"
        >
          <PaginationIcon
            className="far fa-angle-left"
            style={{ fontSize: "20" }}
          />
        </PaginationStepBtn>
      </PaginationLeft>
      <PaginationCenter>
        <PaginationBtn>
          <PaginationText>
            {/* {`${page * pageSize} / ${numPaginationButtons ? numPaginationButtons : 1}`}{" av "}{totalCount} */}
            {`${fromPages} - ${toPages} `}
            {postLabel}
          </PaginationText>
        </PaginationBtn>
      </PaginationCenter>
      <PaginationRight>
        <PaginationStepBtn
          disabled={+page >= +numPaginationButtons ? true : false || loading}
          data-page={+page + 1}
          onClick={+page > +numPaginationButtons ? () => {} : _setPage}
          aria-label="Next"
        >
          <PaginationIcon
            className="far fa-angle-right"
            style={{ fontSize: "20" }}
          />
        </PaginationStepBtn>
        <PaginationStepBtn
          disabled={+page >= +numPaginationButtons ? true : false || loading}
          data-page={+numPaginationButtons}
          onClick={+page >= +numPaginationButtons ? () => {} : _setPage}
          aria-label="Last page"
        >
          <PaginationIcon fontSize={20} className="far fa-arrow-to-right" />
        </PaginationStepBtn>
      </PaginationRight>
    </PaginationWrapper>
  );
};

export default injectIntl(PaginationBar);
